import { Pipe, PipeTransform } from '@angular/core';
import { formatObis } from '../functions/format-obis';

@Pipe({
  name: 'obisFormat',
  standalone: true,
})
export class ObisFormatPipe implements PipeTransform {

  transform(obisCode: string): string {
    return formatObis(obisCode);
  }

}
